import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customerVisibleModifiers'
})
export class CustomerVisibleModifiersPipe implements PipeTransform {
  transform(collection: Array<any>): any {
    if (collection && collection.length) {
      return collection.filter((x) => x.value.isCustomerVisible);
    }
  }
}
